import React from "react";
import { SuccessWallet } from "asset/icons";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "component/ui/Dialog";
import { Button } from "component/ui/Button";

const OpenWalletProcessingModal = ({
    isOpen,
    currencyCode = "USD",
    onClose,
    onBackToDashboard,
    title,
    description,
}) => {
    if (!isOpen) return null;

  const normalizedCode = String(currencyCode || "USD").toUpperCase();

  const modalTitle = title || `Your ${normalizedCode} wallet request received!`;

  const modalDesc = description || "We’re reviewing your details. The wallet will be available within a few minutes.";

  const handleClose = () => {
    if (onBackToDashboard) onBackToDashboard();
    else if (onClose) onClose();
  };

    return (
        <Dialog open={isOpen} onOpenChange={(open) => !open && handleClose()}>
            <DialogContent
                showCloseButton={true}
                className="max-w-[560px] rounded-[16px] bg-white overflow-hidden text-center"
            >
          <div className="flex flex-col p-4 items-center space-y-2">
                  <SuccessWallet />

            <DialogTitle className="text-2xl !mt-0 mb-2 sm:text-2xl font-semibold text-[#020618] text-center">
                        {modalTitle}
                    </DialogTitle>

            <DialogDescription className="text-base !mt-2 text-[#62748E] text-center leading-relaxed md:px-2">
                        {modalDesc}
                    </DialogDescription>
                </div>

          <div style={{border: '1px solid #F2F3FC'}} className="p-4 flex justify-end">
                    <Button
                        onClick={handleClose}
                        className="bg-[#6F00FF] hover:bg-[#5E00DB] text-white font-medium text-sm px-6 py-2.5 rounded-lg transition-all"
                    >
                        Back to dashboard
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default OpenWalletProcessingModal;
